import React, {FC} from 'react';

import {cn} from '@bem-react/classname';
import {Text} from '@gravity-ui/uikit';
import {QuestionImageSize} from 'common/constants/survey';
import MarkdownText from 'ui/components/MarkdownText';
import QuestionLabel from 'ui/components/QuestionLabel';

import QuestionMarkup from '../QuestionMarkup/QuestionMarkup';

import {QuestionLayoutProps, QuestionLayoutType} from './QuestionLayout.types';

import './QuestionLayout.scss';

const cnQuestionLayout = cn('QuestionLayout');

const QuestionLayout: FC<QuestionLayoutProps> = ({
    label: labelText,
    comment: commentText,
    image: imageLinks,
    hint,
    className,
    type,
    control,
    required,
    positions,
    header = false,
    id,
    error,
}) => {
    const controlWithError = (
        <div>
            {control}
            <div aria-live="polite" role="status" className={cnQuestionLayout('ErrorContainer')}>
                {Boolean(error) && (
                    <Text
                        variant="body-1"
                        as="p"
                        color="danger"
                        className={cnQuestionLayout('Error')}
                    >
                        <span id={`${id}-error`}>{error}</span>
                    </Text>
                )}
            </div>
        </div>
    );

    const comment = commentText && (
        <MarkdownText
            key="text"
            text={commentText}
            variant={header ? 'body-2' : 'body-1'}
            color="secondary"
            className={cnQuestionLayout('Comment')}
            id={`${id}-comment`}
        />
    );

    const image = imageLinks && (
        <img
            key="image"
            src={imageLinks[QuestionImageSize.width720]}
            className={cnQuestionLayout('Image')}
            alt=""
        />
    );

    const label = labelText && (
        <QuestionLabel
            key="label"
            text={labelText}
            required={required}
            className={cnQuestionLayout('Label')}
            hint={hint}
            header={header}
            id={`${id}-label`}
            error={error}
        />
    );

    switch (type) {
        case QuestionLayoutType.Column:
        default:
            return (
                <div className={cnQuestionLayout('', {type}, [className])}>
                    <QuestionMarkup
                        label={label}
                        image={image}
                        comment={comment}
                        control={controlWithError}
                        positions={positions}
                    />
                </div>
            );
    }
};
export default QuestionLayout;
